import { render } from "./TransferTransactionDetailsTable.vue?vue&type=template&id=898ace64&ts=true"
import script from "./TransferTransactionDetailsTable.vue?vue&type=script&lang=ts"
export * from "./TransferTransactionDetailsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__